import Config from '@app/dev/config/main';
import { PinForm } from './pieces/PinForm';
import { CpfPhoneNumber } from './pieces/CpfPhoneNumber';
import { CpfRegistrationWithAutoFill } from './pieces/CpfRegistrationWithAutoFill';
import { DefaultRegister } from './pieces/DefaultRegister';
import { isValidCPF } from '@common/helpers/validateCpf';
import { BasicInformationForm } from './pieces/BasicInformationForm';

const pinForm = {
  component: PinForm,
  validate: (form) => {
    const formErrors = {};

    if (!form.pin) formErrors.pin = 'Field is required';
    if (form.pin && form.pin.length !== 4) formErrors.pin = 'Please enter a 4-digits';
    if (!form.confirmPin) formErrors.confirmPin = 'Field is required';
    if ((form.pin && form.confirmPin) && form.pin !== form.confirmPin) formErrors.confirmPin = 'PINs don\'t match';

    return formErrors;
  },
};

const cpfPhoneNumberForm = {
  component: CpfPhoneNumber,
  validate: (form) => {
    const formErrors = {};

    if (!form.cpf) formErrors.cpf = 'Field is required';
    if (form.cpf && form.cpf.length !== 14) formErrors.cpf = 'Invalid format';
    if (!form.phoneNumber) formErrors.phoneNumber = 'Field is required';

    return formErrors;
  },
};

const cpfAutoFillForm = {
  component: CpfRegistrationWithAutoFill,
  validate: (form) => {
    const formErrors = {};

    if (!form.cpf) formErrors.cpf = 'Field is required';
    if (form.cpf && !isValidCPF(form.cpf)) formErrors.cpf = 'Invalid format';
    if (form.cpf && isValidCPF(form.cpf) && !form.FirstName) formErrors.cpf = 'Invalid cpf';

    return formErrors;
  },
};

const basicInformationForm = {
  component: BasicInformationForm,
  validate: (form) => {
    const formErrors = {};

    if (!form.cpf) formErrors.cpf = 'Field is required';
    if (form.cpf && !isValidCPF(form.cpf)) formErrors.cpf = 'Invalid format';
    if (!form.phoneNumber) formErrors.phoneNumber = 'Field is required';
    if (!form.email) formErrors.email = 'Field is required';
    if (!form.password) formErrors.password = 'Field is required';
    if (!form.confirmPassword) formErrors.confirmPassword = 'Field is required';
    if (form.password !== form.confirmPassword) formErrors.confirmPassword = "Passwords don't match";
    if (form.cpf && isValidCPF(form.cpf) && !form.FirstName) formErrors.cpf = 'Invalid cpf';

    return formErrors;
  },
};

const defaultRegister = {
  component: DefaultRegister,
  validate: (form) => {
    const formErrors = {};
    const { registartionCustomField } = Config.main;

    if (!form.customPhoneNumber) formErrors.customPhoneNumber = 'Field is required';
    if (registartionCustomField && (form.customPhoneNumber.phone.length < (registartionCustomField.phoneNumberLength - 4))) formErrors.customPhoneNumber = `Phone number must be ${registartionCustomField.phoneNumberLength - 4} digits`;
    // if (!form.email) formErrors.email = 'Field is required';
    // if (form.email) {
    //   const valid = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(form.email);
    //   if (!valid) formErrors.email = 'Please enter valid email';
    // }
    if (!form.password) formErrors.password = 'Field is required';
    if (!form.confirmPassword) formErrors.confirmPassword = 'Field is required';
    if (form.password !== form.confirmPassword) formErrors.confirmPassword = "Passwords don't match";

    return formErrors;
  },
};

const stepMap = {
  pin: pinForm,
  cpf_auto_fill: cpfAutoFillForm,
  cpf_phone_number: cpfPhoneNumberForm,
  default_register: defaultRegister,
  basic_information: basicInformationForm,
};

export const getStepsList = () => (
  Config.main.registrationSteps.map((step) => ({ name: step.name, step: stepMap[step.name] })).filter(Boolean)
);
